// NGRX
import {createFeatureSelector} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState, Update} from '@ngrx/entity';
// Actions
import {OrdersActions, OrderActionTypes} from '../_actions/order.actions';
// CRUD
import {QueryParamsModel} from '../../_base/crud';
import {Order} from '..';

// Models

export interface OrdersState extends EntityState<Order> {
	listLoading: boolean;
	actionsloading: boolean;
	totalCount: number;
	lastQuery: QueryParamsModel;
	lastCreatedOrderId: number;
	showInitWaitingMessage: boolean;
}

export const adapter: EntityAdapter<Order> = createEntityAdapter<Order>();

export const initialOrdersState: OrdersState = adapter.getInitialState({
	listLoading: false,
	actionsloading: false,
	totalCount: 0,
	lastQuery: new QueryParamsModel({}),
	lastCreatedOrderId: undefined,
	showInitWaitingMessage: true
});

export function ordersReducer(state = initialOrdersState, action: OrdersActions): OrdersState {
	switch (action.type) {
		case OrderActionTypes.OrdersPageToggleLoading:
			return {
				...state, listLoading: action.payload.isLoading, lastCreatedOrderId: undefined
			};
		case OrderActionTypes.OrdersActionToggleLoading:
			return {
				...state, actionsloading: action.payload.isLoading
			};
		case OrderActionTypes.OrderOnServerCreated:
			return {
				...state
			};
		// case OrderActionTypes.OrderCreated:
		// 	return adapter.addOne(action.payload.Order, {
		// 		...state, lastCreatedOrderId: action.payload.product.id
		// 	});
		case OrderActionTypes.OrderUpdated:
			return adapter.updateOne(action.payload.partialOrder, state);
		// case OrderActionTypes.OrdersStatusUpdated: {
		// 	const _partialOrders: Update<Order>[] = [];
		// 	for (let i = 0; i < action.payload.Orders.length; i++) {
		// 		_partialOrders.push({
		// 			id: action.payload.Orders[i].id,
		// 			changes: {
		// 				status: action.payload.status
		// 			}
		// 		});
		// 	}
		// 	return adapter.updateMany(_partialOrders, state);
		// }
		case OrderActionTypes.OneOrderDeleted:
			return adapter.removeOne(action.payload.id, state);
		case OrderActionTypes.ManyOrdersDeleted:
			return adapter.removeMany(action.payload.ids, state);
		case OrderActionTypes.OrdersPageCancelled:
			return {
				...state, listLoading: false, lastQuery: new QueryParamsModel({})
			};
		case OrderActionTypes.OrdersPageLoaded:
			return adapter.addMany(action.payload.Orders, {
				...initialOrdersState,
				totalCount: action.payload.totalCount,
				listLoading: false,
				lastQuery: action.payload.page,
				showInitWaitingMessage: false
			});
		default:
			return state;
	}
}

export const getOrderstate = createFeatureSelector<Order>('orders');

export const {
	selectAll,
	selectEntities,
	selectIds,
	selectTotal
} = adapter.getSelectors();
